import { instance } from '../../../axios/AxiosInstance';

const PATH = 'book-language';

export async function createBookLanguage(body: Record<string, unknown>): Promise<void> {
  await instance.post(PATH, body);
}

export async function updateBookLanguage(body: Record<string, unknown>): Promise<void> {
  await instance.put(PATH, body);
}
